import React from "react";
import { makeRootValidatingTransform } from "./helpers";
import { DEFAULTS } from "./helpers/variables";
export var initialValue = {
  transform: makeRootValidatingTransform(DEFAULTS)
};
export var ThemeContext = React.createContext(initialValue);